import FastClick from 'fastclick'

export default () => FastClick(document.body)
